<template>
  <div class="content-wrapper">
    <invoice-request-table />
  </div>
</template>

<script>
export default {
  name: "InvoiceRequestList",
  data() {
    return {};
  },
};
</script>

<style scoped>
.card {
  box-shadow: 0 10px 12px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
</style>
